// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_ao-6";
export var headerCell = "_ao-2";
export var rowWrapper = "_ao-4";
export var stickyAggregationRow = "_ao-7";
export var table = "_ao-1";
export var virtualRowWrapper = "_ao-5";
export var virtualTableContainer = "_ao-0";
export var white = "_ao-3";